// The writing screen's loading lines (docs/21 §7): what the storyteller is up to while a World is
// written. The first always opens; the rest are shuffled per visit and turn over every few seconds,
// so a five-minute wait shows each about once.
export const OPENING_LINE = 'The storyteller dips the pen…';

export const WRITING_LINES: readonly string[] = [
  OPENING_LINE,
  // the land
  'Naming the rivers…',
  'Raising the mountains a little higher…',
  'Salting the sea…',
  'Drawing the coastline with a shaky hand…',
  'Misplacing an island…',
  'Folding the valleys…',
  'Pouring the marshes…',
  'Planting a forest that remembers…',
  'Giving the wind somewhere to go…',
  'Carving a road nobody finishes…',
  'Digging a well too deep…',
  'Scattering standing stones…',
  'Hiding a lake in the clouds…',
  'Bending the river around a grave…',
  'Filling the caves with echoes…',
  'Sharpening the cliffs…',
  'Warming the hot springs…',
  'Letting the fog in early…',
  'Choosing where the snow stays all year…',
  'Laying an old giant down to make the hills…',
  'Sprinkling ruins along the ridge…',
  'Leaving a crater where a star fell…',
  'Knotting the roots of the old wood…',
  'Tilting the tower just slightly…',
  'Sinking a city beneath the bog…',
  'Pressing ferns into the stone…',
  'Draining the swamp halfway, then giving up…',
  'Giving the desert a secret…',
  'Breaking the bridge in a convenient place…',
  'Naming the crossroads after a hanging…',
  'Burying something under the hill…',
  // history
  'Counting the old kings…',
  'Writing the first treaty…',
  'Breaking the first treaty…',
  'Crowning a king who should not be king…',
  'Forgetting a war on purpose…',
  'Inventing a reason for the old feud…',
  'Losing the royal seal in a pond…',
  'Marrying two houses that hate each other…',
  'Toppling a statue…',
  'Rebuilding the statue, smaller…',
  'Recording a famine in red ink…',
  'Striking a coin with the wrong face on it…',
  'Exiling a prince with a good memory…',
  'Ending an age with a whimper…',
  'Starting an age with a bang…',
  'Erasing a name from the chronicles…',
  'Setting the calendar a day off…',
  'Founding a city on a dare…',
  'Burning the library, then regretting it…',
  'Sealing a pact in candle wax…',
  'Letting an empire crumble slowly…',
  'Choosing which heroes died for nothing…',
  'Choosing which villains were right…',
  'Signing the old charter in blood…',
  'Blaming the dragons for everything…',
  'Misremembering the great flood…',
  'Hiding the true heir among goatherds…',
  'Making a saint out of a liar…',
  'Making a liar out of a saint…',
  'Raising the old walls…',
  'Pulling down the old walls…',
  // monsters
  'Teaching the goblins to hold a grudge…',
  'Polishing the dragon’s hoard…',
  'Counting the dragon’s teeth…',
  'Feeding the trolls under the bridge…',
  'Teaching the kobolds to count, badly…',
  'Giving the ogre a favourite song…',
  'Housebreaking the wolves (mostly)…',
  'Waking something that was sleeping fine…',
  'Sharpening the owlbear’s beak…',
  'Hiding mimics among the treasure chests…',
  'Lining the dungeon with suspicious tiles…',
  'Feeding the gelatinous cube…',
  'Giving the lich a hobby…',
  'Telling the skeletons to stand very still…',
  'Combing the hag’s hair…',
  'Seating the giants at the long table…',
  'Keeping the basilisk away from mirrors…',
  'Untangling the hydra’s heads…',
  'Naming each of the hydra’s heads…',
  'Filling the crypts with patient things…',
  'Training the bats to fly in formation…',
  'Letting the rats grow a little too large…',
  'Giving the goblin chief a pointy hat…',
  'Arming the goblins with whatever was lying around…',
  'Bribing the harpies to sing in tune…',
  'Telling the wyvern it’s a dragon…',
  'Leaving the ghouls a midnight snack…',
  'Teaching the gnolls to laugh at the wrong time…',
  'Teaching the slimes to climb walls…',
  'Persuading the banshee to wait her turn…',
  'Putting a spider in every corner…',
  'Putting a bigger spider in one corner…',
  'Waking the barrow-wights for roll call…',
  'Leaving a troll’s toll unpaid…',
  'Giving the minotaur a maze worth guarding…',
  'Feeding the mimic a decoy coin…',
  // villages and folk
  'Deciding who lies…',
  'Brewing the tavern’s worst ale…',
  'Brewing the tavern’s best ale and hiding it…',
  'Hiring a blacksmith with a past…',
  'Giving the innkeeper a secret cellar…',
  'Watering down the potions…',
  'Raising the prices at the market…',
  'Teaching the town crier new rumours…',
  'Seating the elders by grudge…',
  'Giving every village one suspicious well…',
  'Lighting the lamps in the high street…',
  'Hanging the wanted posters…',
  'Misspelling the names on the wanted posters…',
  'Arguing over the price of turnips…',
  'Teaching the parrot one dreadful word…',
  'Seating a stranger in the corner booth…',
  'Giving the miller three daughters and a debt…',
  'Bribing the gate guard…',
  'Giving the gate guard an honest face…',
  'Hiding a key under the baker’s doormat…',
  'Stocking the apothecary with strange jars…',
  'Labelling one jar “do not”…',
  'Tuning the bard’s lute…',
  'Untuning the bard’s lute, out of spite…',
  'Hiring a fortune teller who is right too often…',
  'Finding the town drunk a prophecy…',
  'Letting the goats escape…',
  'Naming the tavern cat…',
  'Giving the tavern cat a title…',
  'Starting a rumour in the bakery…',
  'Planting turnips where the dead were buried…',
  'Setting the festival for the worst possible night…',
  'Painting a new sign for the Drowned Rat…',
  'Teaching the children a skipping rhyme about the end…',
  'Pinning a map to the tavern wall, slightly wrong…',
  'Giving the mayor three faces…',
  'Keeping a light on in the old mill…',
  'Locking the chapel at sundown…',
  'Leaving one chair empty at the feast…',
  'Raising the toll on the bridge…',
  'Making the blacksmith’s apprentice brave…',
  'Leaving a door unlocked…',
  // magic
  'Stirring the cauldron…',
  'Writing a spell nobody can pronounce…',
  'Bottling a thunderstorm…',
  'Teaching the stars a new constellation…',
  'Losing a wizard’s hat…',
  'Hiding the wizard’s tower in plain sight…',
  'Binding a demon with a very long contract…',
  'Reading the small print on the demon’s contract…',
  'Enchanting a sword with a bad temper…',
  'Cursing a ring, just a little…',
  'Cursing a ring a lot…',
  'Charging the crystals under the full moon…',
  'Inking the runes…',
  'Smudging one of the runes…',
  'Leaving a spellbook open to the wrong page…',
  'Tying the ley lines in a knot…',
  'Turning a prince into a frog, then back, mostly…',
  'Teaching the scarecrow to walk at night…',
  'Feeding the familiar…',
  'Whispering a word of power…',
  'Forgetting the word of power…',
  'Filling the scrying pool…',
  'Polishing the crystal ball…',
  'Weighing the moon…',
  'Brewing a potion that tastes of regret…',
  'Lighting a candle that never burns down…',
  'Splitting a soul into tidy pieces…',
  'Opening a portal, then shutting it quickly…',
  'Turning lead into nearly gold…',
  'Asking the stars what they know…',
  'Leaving the summoning circle unfinished…',
  'Sealing a ghost in a jar…',
  'Labelling the ghost’s jar…',
  'Warding the doors with salt…',
  'Teaching an old staff new tricks…',
  // villains and plots
  'Ringing a bell nobody should hear…',
  'Giving the villain a sympathetic reason…',
  'Giving the villain an unsympathetic laugh…',
  'Polishing the villain’s throne…',
  'Planting the first clue…',
  'Hiding the second clue somewhere obvious…',
  'Burning the third clue…',
  'Writing a prophecy with two meanings…',
  'Adding a third meaning to the prophecy…',
  'Choosing who betrays whom…',
  'Arranging an ambush at the ford…',
  'Sending a letter that arrives too late…',
  'Slipping poison into one goblet…',
  'Swapping the goblets…',
  'Swapping them back…',
  'Hiding a traitor at the high table…',
  'Giving the traitor a good excuse…',
  'Forging the king’s signature…',
  'Leaving a map with an X on it…',
  'Putting the X somewhere unpleasant…',
  'Hiring a mercenary with a conscience…',
  'Giving the assassin a day off…',
  'Knocking three times on a door…',
  'Plotting a coup in a wine cellar…',
  'Raising an army of the not-quite-dead…',
  'Ordering the dark lord’s banners…',
  'Picking the colour of the dark lord’s cloak…',
  'Deciding the dark lord’s cloak is black…',
  'Writing the villain’s monologue…',
  'Cutting the villain’s monologue short…',
  'Hatching a scheme in three acts…',
  'Choosing a name for the cult…',
  'Teaching the cultists to chant in unison…',
  'Giving the cult leader a winning smile…',
  'Setting the doom clock ticking…',
  'Lighting the beacon fires…',
  'Letting the bad news travel fast…',
  'Sealing the last letter with black wax…',
  'Burying a promise with the dead…',
  // dungeons and treasure
  'Hiding the treasure behind the treasure…',
  'Booby-trapping the obvious door…',
  'Booby-trapping the less obvious door…',
  'Oiling the swinging blades…',
  'Filling the pits with spikes…',
  'Filling one pit with feathers, for mercy…',
  'Rolling the great boulder into place…',
  'Counting the gold, then counting it again…',
  'Losing one gold coin down a crack…',
  'Setting the pressure plates…',
  'Hiding a secret passage behind a bookshelf…',
  'Hiding a secret bookshelf behind a passage…',
  'Lighting the torches in the deep halls…',
  'Leaving one torch unlit…',
  'Scratching warnings on the walls…',
  'Scratching misleading warnings on the walls…',
  'Locking the vault with seven keys…',
  'Scattering the seven keys…',
  'Hiding a lever that does nothing…',
  'Hiding a lever that does everything…',
  'Drowning the lower levels…',
  'Sealing a tomb with a riddle…',
  'Thinking of an answer to the riddle…',
  'Carving faces into the doors…',
  'Making one of the faces blink…',
  'Filling the chests with something worse than gold…',
  'Hiding a crown in a pile of bones…',
  'Leaving a sword in a stone…',
  'Gluing the sword into the stone…',
  'Hanging a portrait whose eyes follow you…',
  'Laying out the crypt’s floor plan…',
  'Losing the crypt’s floor plan…',
  'Tucking a skeleton key under a skeleton…',
  'Rusting the portcullis…',
  // gods and heavens
  'Squabbling with the gods…',
  'Giving each god a temper…',
  'Building a temple to a forgotten god…',
  'Letting the old gods sleep a little longer…',
  'Assigning the gods their holy days…',
  'Drawing lots among the gods…',
  'Hiding a god in a mortal’s body…',
  'Feeding the sun its morning oil…',
  'Lighting the stars one by one…',
  'Missing a star, going back for it…',
  'Hanging the moon at a slight angle…',
  'Unrolling the night sky…',
  'Patching a hole in the heavens…',
  'Writing the commandments in small print…',
  'Giving the sea goddess a grudge…',
  'Bargaining with the god of luck…',
  'Losing to the god of luck…',
  'Teaching the comet its path…',
  'Setting the eclipse for maximum drama…',
  'Raising the tides…',
  'Anointing a reluctant priest…',
  'Leaving offerings at the wayside shrine…',
  // weather and hours
  'Brewing a storm over the harbour…',
  'Rolling thunder across the moors…',
  'Letting it rain on the wedding…',
  'Putting frost on the windows…',
  'Sending a cold wind from the north…',
  'Saving the best sunset for later…',
  'Teaching the crows to gossip…',
  'Lengthening the shadows…',
  'Setting the clocks to strike thirteen…',
  'Winding the great clock tower…',
  'Hushing the owls…',
  'Picking the night of the first snow…',
  'Scattering autumn leaves…',
  'Ripening the apples a week early…',
  'Spoiling the harvest, just slightly…',
  'Ordering the swallows south…',
  'Lighting the lanterns along the canal…',
  'Stoking the forge fires…',
  // the road ahead
  'Warming a seat by the fire for the heroes…',
  'Packing rations nobody will enjoy…',
  'Sharpening swords for strangers…',
  'Stitching cloaks for the long road…',
  'Breaking in new boots…',
  'Pinning the first quest to the board…',
  'Pinning a quest nobody should accept…',
  'Writing the reward in very small numbers…',
  'Writing the danger in even smaller letters…',
  'Hiding a healing potion behind a crate…',
  'Leaving a campfire for weary travellers…',
  'Saving a seat for a hero who never came…',
  'Measuring heroes for coffins, just in case…',
  'Rolling the dice behind the screen…',
  'Fudging one roll, kindly…',
  'Deciding how many goblins is too many…',
  'Adding one more goblin…',
  'Choosing the first battlefield…',
  'Lining up the reinforcements…',
  'Hiding a shortcut through the woods…',
  'Leaving a horse at the crossroads…',
  'Forging a letter of introduction…',
  'Rehearsing the quest-giver’s speech…',
  'Giving the quest-giver shifty eyes…',
  'Giving the guide a lantern and a limp…',
  // the storyteller's desk
  'Sharpening the quill…',
  'Spilling ink on the map…',
  'Turning the ink spill into a lake…',
  'Crossing out a chapter…',
  'Writing it back in…',
  'Arguing with the muse…',
  'Checking the spelling of an ancient curse…',
  'Adding footnotes to the footnotes…',
  'Tearing out a page that knew too much…',
  'Burning the first draft…',
  'Scribbling in the margins…',
  'Trimming the candle wick…',
  'Blotting the ink…',
  'Pouring a cup of something strong…',
  'Muttering in the Old Tongue…',
  'Looking up a word in a cursed dictionary…',
  'Staring meaningfully out of the window…',
  'Chewing the end of the quill…',
  'Hiding a joke in the appendix…',
  'Thinking of a good name for a sword…',
  'Giving up and calling the sword Gerald…',
  'Rhyming “doom” with “gloom” again…',
  'Inventing a new colour of dread…',
  'Measuring the darkness…',
  'Weighing the souls…',
  'Shuffling the fates…',
  'Snipping a thread of fate…',
  'Tying the thread back on…',
  'Spinning a yarn…',
  'Knitting the yarn into a scarf…',
  // kitchens and cellars
  'Baking bread for the long winter…',
  'Pickling things best left unpickled…',
  'Salting the pork for the siege…',
  'Seasoning the stew with rumours…',
  'Brewing mead in a dragon’s skull…',
  'Setting the table for an unexpected guest…',
  'Peeling the potatoes of destiny…',
  'Burning the porridge…',
  'Stealing a pie from a windowsill…',
  'Hiding the last honey cake…',
  'Giving the cook a terrible secret…',
  'Uncorking a very old wine…',
  'Pouring a drink for the dead…',
  // beasts of field and wood
  'Teaching the ravens to carry messages…',
  'Teaching the ravens to read them…',
  'Giving one horse opinions…',
  'Letting one sheep wander off…',
  'Waking the bears early…',
  'Hiding a white stag in the deep woods…',
  'Giving the fox a plan…',
  'Counting the bees…',
  'Losing count of the bees…',
  'Teaching the cat to sit on important papers…',
  'Leaving a toad on the throne…',
  // the sea
  'Launching a ship with a bad name…',
  'Painting eyes on the prow…',
  'Hiding a kraken under the harbour…',
  'Telling the kraken to wait…',
  'Charting a route around the whirlpool…',
  'Charting a route through the whirlpool…',
  'Leaving the lighthouse dark one night…',
  'Writing a sea shanty with nine verses…',
  'Burying pirate gold on the wrong island…',
  'Giving the pirate captain one good eye…',
  'Sinking a ship full of secrets…',
  'Washing a message in a bottle ashore…',
  // courts and guilds
  'Founding the Thieves’ Guild…',
  'Taxing the Thieves’ Guild…',
  'Electing a guildmaster by coin toss…',
  'Revoking the merchants’ charter…',
  'Opening a bank with no vault…',
  'Arguing over who sits at the round table’s head…',
  'Hiring spies to watch the spies…',
  'Passing a law against dancing…',
  'Repealing the law against dancing…',
  'Holding a trial by combat…',
  'Holding a trial by baking…',
  'Sending envoys with bad news…',
  'Smuggling something across the border…',
  'Minting a new coin…',
  'Seating the council by who owes whom…',
  'Stamping a thousand writs and losing one…',
  // and the rest
  'Hiding a door that only opens on Tuesdays…',
  'Teaching the echoes to answer back…',
  'Losing a bet with a passing ghost…',
  'Folding the last page into a paper dragon…',
  // grave matters
  'Pricing the funerals in advance…',
  'Ordering the gravestones in bulk…',
  'Leaving the epitaphs blank, for now…',
  'Teaching the gravedigger to whistle…',
  'Booking the undertaker for the whole season…',
  'Writing a will for each hero, just in case…',
  'Sharpening the guillotine for the festival…',
  'Reserving plots in the churchyard…',
  'Asking the necromancer to stay on call…',
  'Carving “Here Lies” and leaving room…',
  'Hiring a bard to write the elegies early…',
  'Stocking up on black armbands…',
  'Teaching the ravens which heroes to watch…',
  'Hanging the heroes’ portraits beside the last party’s…',
  'Checking the last party’s notes for warnings…',
  'Clearing out the last party’s rooms…',
  'Selling the last party’s boots…',
  'Telling the widows it was quick…',
  'Writing “probably fine” on the dungeon map…',
  'Giving the traps a sense of humour…',
  'Raising the reward after the last three died…',
  'Promising the survivors a parade…',
  'Planning a smaller parade…',
  'Deciding the parade can be a toast…',
  'Teaching the healer to say “just a scratch”…',
  'Mopping up after the previous heroes…',
  'Recycling the previous heroes’ swords…',
  'Recruiting the previous heroes as skeletons…',
  'Practising a sombre face for the eulogy…',
  'Polishing the mourning bell…',
  'Adding a “you are here” to the crypt…',
  'Rounding the death toll down…',
  'Rewording “certain doom” as “a challenge”…',
  'Leaving a resurrection scroll just out of reach…',
  'Pricing resurrection very, very high…',
  'Telling the ghosts to save the good haunts…',
  'Watching the vultures circle, hopefully…',
  'Feeding the dragon the last quest-giver…',
  'Testing the trapdoor on an apprentice…',
  'Assuring the heroes the curse is mostly cosmetic…',
];
